import { render, staticRenderFns } from "./diagnostic_center_details.vue?vue&type=template&id=0f64e8c1&scoped=true"
import script from "./diagnostic_center_details.vue?vue&type=script&lang=js"
export * from "./diagnostic_center_details.vue?vue&type=script&lang=js"
import style0 from "./diagnostic_center_details.vue?vue&type=style&index=0&id=0f64e8c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f64e8c1",
  null
  
)

export default component.exports